import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import MaskInput from 'components/MaskedInput';
import { unMaskInputValue } from 'utils/helpers';

import { useDisplayUtils } from '../utils/displayUtils';
// eslint-disable-next-line import/extensions
import { useCroptimizer } from '../../../../../../../providers/CroptimizerContext.tsx';
// eslint-disable-next-line import/extensions
import useCurrency from '../../../../../../../../../hooks/useCurreny.tsx';

interface TotalGainSectionProps {
  cleaneffiN: string;
  cleaneffiP: string;
  cleaneffiK: string;
  onlyAc: string;
}

const TotalGainSection: FC<TotalGainSectionProps> = ({
  cleaneffiN,
  cleaneffiP,
  cleaneffiK,
}) => {
  const { t } = useTranslation();
  const { getTextOfTotal } = useDisplayUtils();
  const { isMaintenanceMode, boardStatusValues, onlyAc } = useCroptimizer();

  const getTotalGain = useMemo(() => {
    const result = Number(cleaneffiN) + Number(cleaneffiP) + Number(cleaneffiK);

    return String(Math.round(result));
  }, [cleaneffiN, cleaneffiP, cleaneffiK]);

  const maintenanceText = useMemo(() => {
    if (isMaintenanceMode && boardStatusValues?.currentPh) {
      return ` en maintenant le pH à ${boardStatusValues.currentPh.replace('.', ',')}`;
    }

    return '';
  }, [isMaintenanceMode, boardStatusValues?.currentPh]);

  const { currencyGreen } = useCurrency();

  return (
    <div className="py-8">
      <div className="text-black font-bold md:text-lg mb-8">
        {t('totalNpkGain')}
        {isMaintenanceMode ? maintenanceText : getTextOfTotal} ({currencyGreen}/{onlyAc})
      </div>
      <div className="flex mx-[-0.5rem]">
        <div className="w-1/3 md:w-full px-2 break-inside-avoid">
          <MaskInput
            titleClassName="top-[-9px] left-[8px] bg-disable-gradient"
            title='NPK'
            className="w-full"
            disabled
            isBlueBg
            value={unMaskInputValue(getTotalGain)}
          />
        </div>
      </div>
    </div>
  );
};

export default TotalGainSection;
